<div [class]="'btn-bkg ' + size">
  <img [src]="'sdk/play.svg' | assetsPath | async" class="play-control" alt="" />
</div>
